<template>
  <div
    class="is-fullwidth trial-notification-bar has-background-warning"
    v-if="showNotificationBar"
  >
    <div>
      <div v-if="totalStoragePercent >= triggerPoint" class="is-pulled-left">
        <p>
          <small>
            <strong>
              You are using {{ totalStoragePercent }}% of
              {{ formattedMaxStorage }} allowed by your {{ plan }} plan. Please
              upgrade to increase your limits or clean up some old documents.
            </strong>
            <span> Upgrade your {{ plan }} plan to get more benefits. </span>
          </small>
        </p>
      </div>
      <div v-if="totalDocumentsPercent >= triggerPoint" class="is-pulled-left">
        <p>
          <small>
            <strong>
              You can upload {{ totalDocumentsLeft }} more documents in your
              {{ plan }} plan.
            </strong>
            <span> Please upgrade to get unlimited documents. </span>
          </small>
        </p>
      </div>
      <trial-button
        :displayText="upgradeButton.displayText"
        :path="upgradeButton.path"
      ></trial-button>
    </div>
  </div>
</template>
<script>
import TrialButton from './shared/TrialButton';
import { formatBytes } from '@/utils/general';

// TODO Refactor Notifications component
export default {
  name: 'UsageNotificationBar',
  data() {
    return {
      upgradeButton: {
        path: '/profile/upgrade',
        displayText: 'Upgrade your plan'
      },
      triggerPoint: 90
    };
  },
  components: { TrialButton },
  methods: {
    getTotalStorage() {
      return this.$store.getters['documents/getDocumentsTotalStorage'];
    },
    maxStorage() {
      const user = this.getUser();
      const maxStorage = user
        ? parseInt(
            user.account?.subscription?.plan?.features?.storage?.value || 0
          )
        : 0;
      return maxStorage;
    },
    maxDocuments() {
      const user = this.getUser();
      const maxDocuments = user
        ? parseInt(
            user.account?.subscription?.plan?.features?.documents?.value || 0
          )
        : 0;
      return maxDocuments;
    },
    getUser() {
      const user = this.$store.getters['auth/getUser'];
      return user && user._id && user.account ? user : null;
    },
    calculatePercent(currentValue, maxValue) {
      const percent = ((currentValue / maxValue) * 100).toFixed(0);
      return percent !== 'Infinity' ? percent : 0;
    }
  },
  computed: {
    plan() {
      const user = this.$store.getters['auth/getUser'];
      if (user && user._id) {
        return user.account.subscription.plan.name;
      }
      return false;
    },
    formattedMaxStorage() {
      return formatBytes(this.maxStorage());
    },
    totalDocumentsLeft() {
      const maxDocuments = this.maxDocuments();
      const totalStorage = this.getTotalStorage();
      return maxDocuments - totalStorage?.count;
    },
    totalStoragePercent() {
      const totalStorage = this.getTotalStorage();
      const maxStorage = this.maxStorage();
      return this.calculatePercent(totalStorage?.usedStorage, maxStorage);
    },
    totalDocumentsPercent() {
      const totalStorage = this.getTotalStorage();
      const maxDocuments = this.maxDocuments();
      return this.calculatePercent(totalStorage?.count, maxDocuments);
    },
    currentMonth() {
      return this.$moment().format('MMMM');
    },
    showNotificationBar() {
      return (
        this.totalStoragePercent >= this.triggerPoint ||
        this.totalDocumentsPercent >= this.triggerPoint
      );
    }
  }
};
</script>
